import { Button, Checkbox, Col, Form, Input, Row, Space } from "antd";
import { useEffect, useState } from "react";

const CompanyBaseItem = ({ itemDefault, onClose, onDelete }) => {
  const [form] = Form.useForm();
  const [item, setItem] = useState({...itemDefault});

  useEffect(() => form.setFieldsValue(item), [])

  const onValuesChange = value => setItem({...item, ...value});

  return<div>
    <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} colon={false}>
      <Form.Item label="Пользователь">
        <Row>
          <Col span={10}><Form.Item name="name"><Input /></Form.Item></Col>
          <Col span={2}/>
          <Col span={12}><Form.Item name="isAct" valuePropName="checked"><Checkbox>Активный</Checkbox></Form.Item></Col>
        </Row>
      </Form.Item>
      <Form.Item label="Настройки">
        <Row>
          <Col span={10}><Form.Item name="isNstr" valuePropName="checked"><Checkbox>Получать</Checkbox></Form.Item></Col>
          <Col span={14}><Form.Item label="Коэффициент цены" name="coeff"><Input /></Form.Item></Col>
        </Row>
      </Form.Item>
      <Form.Item label="Пакеты">
        <Row>
          <Col span={6}><Form.Item name="isPack" valuePropName="checked"><Checkbox>Отправлять</Checkbox></Form.Item></Col>
          <Col span={1}/>
          <Col span={8}><Form.Item name="depnoOld" label="С отдела"><Input /></Form.Item></Col>
          <Col span={1}/>
          <Col span={8}><Form.Item name="depnoNew" label="На отдел"><Input /></Form.Item></Col>
        </Row>
      </Form.Item>
      <Form.Item label="Комментарий" name="comment"><Input /></Form.Item>
      <Form.Item label=" ">
        <Space>
          <Button onClick={() => onDelete(item.id)}>Удалить</Button>
          <Button onClick={() => onClose(item)}>Сохранить</Button>
          <Button onClick={() => onClose(false)}>Отмена</Button>
        </Space>
      </Form.Item>
    </Form>
  </div>
}

export default CompanyBaseItem;